<button mat-icon-button (click)="openPanel()" #notificationsOrigin>
    <ng-container *ngIf="unreadCount > 0">
        <span class="absolute top-0 right-0 left-0 flex items-center justify-center h-3">
            <span
                class="flex items-center justify-center flex-shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full bg-teal-600 text-indigo-50 text-xs font-medium">
                {{unreadCount}}
            </span>
        </span>
    </ng-container>
    <mat-icon [svgIcon]="'heroicons_outline:bell'"></mat-icon>
</button>

<ng-template #notificationsPanel>
    <div
        class="fixed inset-0 md:static md:inset-auto flex flex-col md:min-w-100 md:w-100 md:rounded-2xl overflow-hidden shadow-lg notification-container">
        <div class="flex flex-shrink-0 items-center py-4 pr-4 pl-6 bg-primary text-on-primary">
            <div class="md:hidden -ml-1 mr-3">
                <button mat-icon-button (click)="closePanel()">
                    <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:x'"></mat-icon>
                </button>
            </div>
            <div class="text-md md:text-lg font-medium leading-10">Notifications</div>
            <div class="ml-auto hidden">
                <button mat-icon-button [matTooltip]="'Mark all as read'" [disabled]="unreadCount === 0"
                    (click)="markAllAsRead(filteredNotifications)">
                    <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:mail-open'"></mat-icon>
                </button>
            </div>
        </div>
        <mat-tab-group class="bg-white w-full py-2">
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="mr-2" [svgIcon]="'heroicons_solid:mail-open'"></mat-icon>
                    <span class="text-md md:text-xl">Notifications</span>
                    <span class="text-md md:text-xl">
                        <span *ngIf="unreadNotificationsCount > 0" class="absolute top-0 right-4 w-full left-[30px] flex items-center justify-end h-3">
                            <span
                                class="flex items-center justify-center flex-shrink-0 min-w-4 h-4 px-1 ml-4 mt-1.5 mr-3 rounded-full bg-teal-600 text-indigo-50 text-xs font-medium">
                            {{unreadNotificationsCount}}
                            </span>
                        </span>
                    </span>
                </ng-template>

                <ng-template matTabContent class="p-0">
                    <div class="relative flex flex-col flex-auto sm:max-h-120 divide-y overflow-y-auto bg-card">
                        <div class="flex flex-row justify-between items-center">
                            <div class="py-2">
                                <button mat-button [matTooltip]="'Mark all as read'" [disabled]="unreadCount === 0"
                                    (click)="markAllAsRead(filteredNotifications)">
                                    <mat-icon class="icon-size-5 text-current"
                                        [svgIcon]="'heroicons_solid:mail-open'"></mat-icon>
                                    <div class="ml-1 text-md md:text-lg">Mark all as read</div>
                                </button>
                            </div>
                            <div class="flex items-center h-10 min-h-10 cursor-pointer hover:bg-hover"
                                (click)="onlyUnread('notifications', $event)" matRipple>
                                <mat-checkbox class="flex items-center h-10 min-h-10" [color]="'primary'"
                                    [checked]="unreadNotifications">
                                </mat-checkbox>
                                <div class="ml-1 text-md md:text-lg">Only Unread</div>
                            </div>
                        </div>
                        <ng-container *ngFor="let notification of filteredNotifications; trackBy: trackByFn">
                            <div class="flex group hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5"
                                [ngClass]="{'unread': notification.readAt === null}">
                                <ng-container *ngIf="notification.link">
                                    <ng-container *ngIf="!notification.useRouter">
                                        <a class="flex flex-auto py-5 pl-6 cursor-pointer text-blue-500"
                                            [href]="notification.link">
                                            <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                                        </a>
                                    </ng-container>
                                    <ng-container *ngIf="notification.useRouter">
                                        <a class="flex flex-auto py-5 pl-6 cursor-pointer text-blue-500"
                                            [routerLink]="notification.link">
                                            <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                                        </a>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="!notification.link">
                                    <div class="flex flex-auto py-5 pl-6">
                                        <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                                    </div>
                                </ng-container>
                                <div class="relative flex flex-col my-5 mr-6 ml-2">
                                    <button class="w-6 h-6 min-h-6" mat-icon-button (click)="toggleRead(notification)"
                                        [matTooltip]="notification.readAt !== null ? 'Mark as unread' : 'Mark as read'">
                                        <span class="w-2 h-2 rounded-full" [ngClass]="{'bg-gray-400 dark:bg-gray-500 sm:opacity-0 sm:group-hover:opacity-100': notification.readAt,
                                            'bg-primary': notification.readAt === null}"></span>
                                    </button>
                                    <!-- <button class="w-6 h-6 min-h-6 sm:opacity-0 sm:group-hover:opacity-100"
                                        mat-icon-button (click)="delete(notification)" [matTooltip]="'Remove'">
                                        <mat-icon class="icon-size-4" [svgIcon]="'heroicons_solid:x'"></mat-icon>
                                    </button> -->
                                </div>
                            </div>
                            <ng-template #notificationContent>
                                <ng-container *ngIf="notification.icon && !notification.image">
                                    <div
                                        class="flex flex-shrink-0 items-center justify-center w-8 h-8 mr-4 rounded-full bg-gray-100 dark:bg-gray-700">
                                        <mat-icon class="icon-size-5" [svgIcon]="notification.icon">
                                        </mat-icon>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="notification.image">
                                    <img class="flex-shrink-0 w-8 h-8 mr-4 rounded-full overflow-hidden object-cover object-center"
                                        [src]="notification.image" [alt]="'Notification image'">
                                </ng-container>
                                <div class="flex flex-col flex-auto">
                                    <ng-container *ngIf="notification.title">
                                        <div class="font-semibold line-clamp-3 text-md md:text-lg "
                                            [innerHTML]="notification.title"></div>
                                    </ng-container>
                                    <ng-container *ngIf="notification.description">
                                        <div class="line-clamp-2" [innerHTML]="notification.description"></div>
                                    </ng-container>
                                    <div class="mt-2 text-sm leading-none text-secondary">
                                        {{notification.created | date:'MMM dd YYYY, h:mm a'}}
                                    </div>
                                </div>
                            </ng-template>
                        </ng-container>
                        <ng-container *ngIf="!filteredNotifications || !filteredNotifications.length">
                            <div
                                class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8">
                                <div
                                    class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100">
                                    <mat-icon class="text-primary-500-700"
                                        [svgIcon]="'heroicons_outline:bell'"></mat-icon>
                                </div>
                                <div class="mt-5 text-xl md:text-2xl font-semibold tracking-tight">No
                                    notifications</div>
                                <div class="w-full max-w-60 mt-1 text-md text-center text-secondary">When
                                    you have
                                    notifications,
                                    they will appear here.</div>
                            </div>
                        </ng-container>
                    </div>
                </ng-template>
            </mat-tab>

            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="mr-2" [svgIcon]="'heroicons_solid:bell'"></mat-icon>
                    <span class="text-md md:text-xl">Alerts</span>
                    <span *ngIf="unreadAlertsCount > 0" class="text-md md:text-xl">
                        <span class="absolute top-0 right-4 w-full left-[30px] flex items-center justify-end h-3">
                            <span
                                class="flex items-center justify-center flex-shrink-0 min-w-4 h-4 px-1 ml-4 mt-1.5 mr-3 rounded-full bg-teal-600 text-indigo-50 text-xs font-medium">
                            {{unreadAlertsCount}}
                            </span>
                        </span>
                    </span>
                </ng-template>

                <ng-template matTabContent class="p-0">
                    <div class="relative flex flex-col flex-auto sm:max-h-120 divide-y overflow-y-auto bg-card">
                        <div class="flex flex-row justify-between items-center">
                            <div class="py-2">
                                <button mat-button [matTooltip]="'Mark all as read'" [disabled]="unreadCount === 0"
                                    (click)="markAllAsRead(filteredAlerts)">
                                    <mat-icon class="icon-size-5 text-current"
                                        [svgIcon]="'heroicons_solid:mail-open'"></mat-icon>
                                    <div class="ml-1 text-md md:text-lg">Mark all as read</div>
                                </button>
                            </div>
                            <div class="flex items-center h-10 min-h-10 cursor-pointer hover:bg-hover"
                                (click)="onlyUnread('alerts', $event)" matRipple>
                                <mat-checkbox class="flex items-center h-10 min-h-10" [color]="'primary'"
                                    [checked]="unreadAlerts">
                                </mat-checkbox>
                                <div class="ml-1 text-md md:text-lg">Only Unread</div>
                            </div>
                        </div>
                        <ng-container *ngFor="let notification of filteredAlerts; trackBy: trackByFn">
                            <div class="flex group hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5"
                                [ngClass]="{'unread': notification.readAt === null}">
                                <ng-container *ngIf="notification.link">
                                    <ng-container *ngIf="!notification.useRouter">
                                        <a class="flex flex-auto py-5 pl-6 cursor-pointer text-blue-500"
                                            [href]="notification.link">
                                            <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                                        </a>
                                    </ng-container>
                                    <ng-container *ngIf="notification.useRouter">
                                        <a class="flex flex-auto py-5 pl-6 cursor-pointer text-blue-500"
                                            [routerLink]="notification.link">
                                            <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                                        </a>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="!notification.link">
                                    <div class="flex flex-auto py-5 pl-6">
                                        <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                                    </div>
                                </ng-container>
                                <div class="relative flex flex-col my-5 mr-6 ml-2">
                                    <button class="w-6 h-6 min-h-6" mat-icon-button (click)="toggleRead(notification)"
                                        [matTooltip]="notification.readAt !== null ? 'Mark as unread' : 'Mark as read'">
                                        <span class="w-2 h-2 rounded-full" [ngClass]="{'bg-gray-400 dark:bg-gray-500 sm:opacity-0 sm:group-hover:opacity-100': notification.readAt,
                                        'bg-primary': notification.readAt === null}"></span>
                                    </button>
                                    <!-- <button class="w-6 h-6 min-h-6 sm:opacity-0 sm:group-hover:opacity-100"
                                    mat-icon-button (click)="delete(notification)" [matTooltip]="'Remove'">
                                    <mat-icon class="icon-size-4" [svgIcon]="'heroicons_solid:x'"></mat-icon>
                                </button> -->
                                </div>
                            </div>
                            <ng-template #notificationContent>
                                <ng-container *ngIf="notification.icon && !notification.image">
                                    <div
                                        class="flex flex-shrink-0 items-center justify-center w-8 h-8 mr-4 rounded-full bg-gray-100 dark:bg-gray-700">
                                        <mat-icon class="icon-size-5" [svgIcon]="notification.icon">
                                        </mat-icon>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="notification.image">
                                    <img class="flex-shrink-0 w-8 h-8 mr-4 rounded-full overflow-hidden object-cover object-center"
                                        [src]="notification.image" [alt]="'Notification image'">
                                </ng-container>
                                <div class="flex flex-col flex-auto">
                                    <ng-container *ngIf="notification.title">
                                        <div class="font-semibold line-clamp-3 text-md md:text-lg"
                                            [innerHTML]="notification.title"></div>
                                    </ng-container>
                                    <ng-container *ngIf="notification.description">
                                        <div class="line-clamp-2" [innerHTML]="notification.description"></div>
                                    </ng-container>
                                    <div class="mt-2 text-sm leading-none text-secondary">
                                        {{notification.created | date:'MMM dd YYYY, h:mm a'}}
                                    </div>
                                </div>
                            </ng-template>
                        </ng-container>
                        <ng-container *ngIf="!filteredAlerts || !filteredAlerts.length">
                            <div
                                class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8">
                                <div
                                    class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100">
                                    <mat-icon class="text-primary-500-700"
                                        [svgIcon]="'heroicons_outline:bell'"></mat-icon>
                                </div>
                                <div class="mt-5 text-xl md:text-2xl font-semibold tracking-tight">No
                                    alerts</div>
                                <div class="w-full max-w-60 mt-1 text-md text-center text-secondary">When
                                    you have
                                    alerts,
                                    they will appear here.</div>
                            </div>
                        </ng-container>
                    </div>
                </ng-template>
            </mat-tab>

            <mat-tab *ngIf="isClient">
                <ng-template mat-tab-label>
                    <mat-icon class="mr-2" [svgIcon]="'heroicons_solid:chat'"></mat-icon>
                    <span class="text-md md:text-xl">Chats</span>
                </ng-template>

                <ng-template matTabContent class="p-0">
                    <div class="relative flex flex-col flex-auto sm:max-h-120 divide-y overflow-y-auto bg-card">
                        <div class="flex flex-row justify-between items-center">
                            <div class="py-2">
                                <button mat-button [matTooltip]="'Mark all as read'" [disabled]="unreadCount === 0"
                                    (click)="markAllAsRead(filteredChats)">
                                    <mat-icon class="icon-size-5 text-current"
                                        [svgIcon]="'heroicons_solid:mail-open'"></mat-icon>
                                    <div class="ml-1 text-md md:text-lg">Mark all as read</div>
                                </button>
                            </div>
                            <div class="flex items-center h-10 min-h-10 cursor-pointer hover:bg-hover"
                                (click)="onlyUnread('message', $event)" matRipple>
                                <mat-checkbox class="flex items-center h-10 min-h-10" [color]="'primary'"
                                    [checked]="unreadChats">
                                </mat-checkbox>
                                <div class="ml-1 text-md md:text-lg">Only Unread</div>
                            </div>
                        </div>
                        <ng-container *ngFor="let notification of filteredChats; trackBy: trackByFn">
                            <div class="flex group hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5"
                                [ngClass]="{'unread': notification.readAt === null}">
                                <ng-container *ngIf="notification.link">
                                    <ng-container *ngIf="!notification.useRouter">
                                        <a class="flex flex-auto py-5 pl-6 cursor-pointer text-blue-500"
                                            [href]="notification.link">
                                            <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                                        </a>
                                    </ng-container>
                                    <ng-container *ngIf="notification.useRouter">
                                        <a class="flex flex-auto py-5 pl-6 cursor-pointer text-blue-500"
                                            [routerLink]="notification.link">
                                            <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                                        </a>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="!notification.link">
                                    <div class="flex flex-auto py-5 pl-6">
                                        <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                                    </div>
                                </ng-container>
                                <div class="relative flex flex-col my-5 mr-6 ml-2">
                                    <button class="w-6 h-6 min-h-6" mat-icon-button (click)="toggleRead(notification)"
                                        [matTooltip]="notification.readAt !== null ? 'Mark as unread' : 'Mark as read'">
                                        <span class="w-2 h-2 rounded-full" [ngClass]="{'bg-gray-400 dark:bg-gray-500 sm:opacity-0 sm:group-hover:opacity-100': notification.readAt,
                                        'bg-primary': notification.readAt === null}"></span>
                                    </button>
                                    <!-- <button class="w-6 h-6 min-h-6 sm:opacity-0 sm:group-hover:opacity-100"
                                    mat-icon-button (click)="delete(notification)" [matTooltip]="'Remove'">
                                    <mat-icon class="icon-size-4" [svgIcon]="'heroicons_solid:x'"></mat-icon>
                                </button> -->
                                </div>
                            </div>
                            <ng-template #notificationContent>
                                <ng-container *ngIf="notification.icon && !notification.image">
                                    <div
                                        class="flex flex-shrink-0 items-center justify-center w-8 h-8 mr-4 rounded-full bg-gray-100 dark:bg-gray-700">
                                        <mat-icon class="icon-size-5" [svgIcon]="notification.icon">
                                        </mat-icon>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="notification.fileUrl">
                                    <img class="flex-shrink-0 w-8 h-8 mr-4 rounded-full overflow-hidden object-cover object-center"
                                        [src]="notification.fileUrl" [alt]="'Notification image'">
                                </ng-container>
                                <div class="flex flex-col flex-auto">
                                    <ng-container *ngIf="notification.title">
                                        <div class="font-semibold line-clamp-3 text-md md:text-lg"
                                            [innerHTML]="notification.title"></div>
                                    </ng-container>
                                    <ng-container *ngIf="notification.subjectId">
                                        <div class="font-semibold line-clamp-3 text-md md:text-lg"
                                            >Audit:#{{notification.subjectId}}</div>
                                    </ng-container>
                                    <ng-container *ngIf="notification.description">
                                        <div class="line-clamp-2" [innerHTML]="notification.description"></div>
                                    </ng-container>
                                    <div class="mt-2 text-sm leading-none text-secondary">
                                        {{notification.created | date:'MMM dd YYYY, h:mm a'}}
                                    </div>
                                </div>
                            </ng-template>
                        </ng-container>
                        <ng-container *ngIf="!filteredChats || !filteredChats.length">
                            <div
                                class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8">
                                <div
                                    class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100">
                                    <mat-icon class="text-primary-500-700"
                                        [svgIcon]="'heroicons_outline:bell'"></mat-icon>
                                </div>
                                <div class="mt-5 text-xl md:text-2xl font-semibold tracking-tight">No
                                    Chats</div>
                                <div class="w-full max-w-60 mt-1 text-md text-center text-secondary">When
                                    you have
                                    chats,
                                    they will appear here.</div>
                            </div>
                        </ng-container>
                    </div>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>
</ng-template>
